import React from 'react';


export type BaseRequestItemProps = {
    requestId: string;
    avatar?: React.ReactNode;
    title: string;
    description: string;
    children: React.ReactNode;
    actions?: React.ReactNode;
};

export function BaseRequestItem({
                                    requestId,
                                    avatar,
                                    title,
                                    description,
                                    children,
                                    actions
                                }: BaseRequestItemProps) {
    return (
        <div key={requestId} className="flex items-center py-4 border-b border-gray-200 last:border-b-0">
            {avatar && (
                <div className="mr-4">
                    {avatar}
                </div>
            )}

            <div className="flex-1">
                <div className="flex justify-between items-center gap-4">
                    <div className="flex flex-col">
                        <div className="flex flex-col">
                            <div className="text-sm font-medium text-gray-900">
                                {title}
                            </div>
                            <div className="text-sm text-gray-600">{description}</div>
                        </div>
                        {children}
                    </div>

                    {actions && (
                        <div className="flex gap-2 shrink-0">
                            {actions}
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
}